import { Wifi, WifiOff } from 'lucide-react';
import { useConnectionStatus } from '@/hooks/useConnectionStatus';

export function ConnectionBanner() {
  const status = useConnectionStatus();

  if (status === null) return null;

  const isOffline = status === 'offline';
  const Icon = isOffline ? WifiOff : Wifi;
  const message = isOffline
    ? 'No internet connection. Some features may not work.'
    : 'Back online';

  return (
    <div
      role="status"
      aria-live="polite"
      className={`sticky top-0 z-[60] flex w-full items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-white ${
        isOffline ? 'bg-black' : 'bg-green-950'
      }`}
    >
      <Icon className="h-4 w-4" aria-hidden="true" />
      <span>{message}</span>
    </div>
  );
}
